import { ParseEmailResponse, SaveDisplayedPricesRequest } from 'apiConnector/smart-quote/model';
import { ISalesCounterpart } from 'models/ISalesCounterpart';
import { SmartQuotePrompt } from 'state/workspaces/smart-quote/model';
import {
  NextSmartQuoteParsingResultEvent,
  NextSmartQuoteParsingStartEvent,
  NextSmartQuoteResponseEvent,
  SmartQuoteClosedEvent,
  SmartQuoteParsingErrorEvent,
  SmartQuoteTotalCount,
} from 'utils/streaming/smart-quote';

export type SmartQuoteWorkspaceActions = ReturnType<(typeof smartQuoteActions)[keyof typeof smartQuoteActions]>;
export type ParsingResult = ReturnType<typeof smartQuoteActions.parsingResult>;
export type QuoteResponse = ReturnType<typeof smartQuoteActions.quoteResponse>;
export type ParsingFinished = ReturnType<typeof smartQuoteActions.parsingFinished>;
export type AddResultsTotalCount = ReturnType<typeof smartQuoteActions.addResultsTotalCount>;

export const smartQuoteActions = {
  addClientCheckStep: (tabId: string, promptId: string, filename: string, pendingFile: string) => ({
    type: 'ADD_CLIENT_CHECK_STEP' as const,
    tabId,
    promptId,
    filename,
    pendingFile,
  }),
  parseEmailSuccess: (
    tabId: string,
    filename: string,
    parseEmailResponse: ParseEmailResponse,
    selectedOnBehalfClient: ISalesCounterpart | undefined,
  ) => ({
    type: 'PARSE_EMAIL_SUCCESS' as const,
    tabId,
    filename,
    ...parseEmailResponse,
    selectedOnBehalfClient,
  }),
  parsingError: (
    tabId: string,
    { type: _t, id, promptId, ...smartQuoteParsingError }: SmartQuoteParsingErrorEvent,
  ) => ({
    type: 'PARSING_ERROR' as const,
    tabId,
    id,
    promptId,
    error: smartQuoteParsingError,
  }),
  parsingStart: (tabId: string, { type: _t, ...nextSmartQuoteParsingStart }: NextSmartQuoteParsingStartEvent) => ({
    type: 'PARSING_START' as const,
    tabId,
    ...nextSmartQuoteParsingStart,
  }),
  parsingResult: (tabId: string, { type: _t, ...nextSmartQuoteParsingResult }: NextSmartQuoteParsingResultEvent) => ({
    type: 'PARSING_RESULT' as const,
    tabId,
    ...nextSmartQuoteParsingResult,
  }),
  quoteResponse: (tabId: string, { type: _t, ...nextSmartQuoteResponse }: NextSmartQuoteResponseEvent) => ({
    type: 'QUOTE_RESPONSE' as const,
    tabId,
    ...nextSmartQuoteResponse,
  }),
  parsingFinished: (tabId: string, { type: _t, ...smartQuoteClosedEvent }: SmartQuoteClosedEvent) => ({
    type: 'PARSING_FINISHED' as const,
    tabId,
    ...smartQuoteClosedEvent,
  }),
  addResultsTotalCount: (tabId: string, { type: _t, ...smartQuoteTotalCount }: SmartQuoteTotalCount) => ({
    type: 'ADD_RESULTS_TOTAL_COUNT' as const,
    tabId,
    ...smartQuoteTotalCount,
  }),
  loadPromptsByIdsRequested: (tabId: string) => ({
    type: 'LOAD_PROMPTS_BY_IDS_REQUESTED' as const,
    tabId,
  }),
  promptFetched: (tabId: string, prompts: SmartQuotePrompt[]) => ({
    type: 'PROMPTS_FETCHED' as const,
    tabId,
    prompts,
  }),
  updateIsDisplayedPrice: (saveDisplayedPricesRequest: SaveDisplayedPricesRequest) => ({
    type: 'UPDATE_IS_DISPLAYED_PRICE' as const,
    tabId: saveDisplayedPricesRequest.tabId,
    promptId: saveDisplayedPricesRequest.promptId,
    displayedPrices: saveDisplayedPricesRequest.displayedPrices,
  }),
};
